module.exports = __webpack_public_path__ + "static/media/glass-medical-search-svgrepo-com.afc657c6.svg";